import { createTheme } from "@mui/material";

const lexendFont = {
  fontFamily: "Lexend, Arial, sans-serif",
};

const theme = createTheme({
  palette: {
    primary: {
      main: "#78CA72",
    },
    secondary: {
      main: "#D3FAD9",
    },
    hover: {
      main: "#548D4F",
    },
    salmon: {
      main: "#EB9D84",
    },
  },
  typography: {
    fontFamily: "Lexend, Arial, sans-serif", // Set the default font for the entire app
    button: {
      textTransform: "none",
    },
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": [lexendFont],
      },
    },
  },
  components: {
    MuiMenu: {
      styleOverrides: {
        list: {
          "&.css-6hp17o-MuiList-root-MuiMenu-list": {
            height: "auto", // Or any other value that fits
          },
        },
      },
    },
  },
});

export default theme;
